// extracted by mini-css-extract-plugin
export default {"reportModal":"yH9LW","loader":"_2VxMp","reasons":"_16DPh","error":"_1q0PW","inputComment":"_3huhF","submitBtn":"_2uKi8","reportModalLetgo":"_2OMqY"};